import { Component } from '@angular/core';

@Component({
  selector: 'app-error-notfound',
  templateUrl: './error-notfound.component.html',
})
export class ErrorNotFoundComponent {}
